/**
 * Extracts the problemTypeKey from a ReviewType.
 * Example: "design_rule_check_erc_similar_labels" -> "erc_similar_labels"
 */
export function getProblemTypeKeyFromReviewType(reviewType) {
    return reviewType.replace("design_rule_check_", "");
}
//# sourceMappingURL=types.js.map